module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"authorizationRequest":"Authorization request","application":"Application","requiresAccess":"requires access to your account","deny":"Cancel","approve":"Approve","chooseAnotherAccount":"Choose another account","slogan":"The first automated interview service with a real person"}}')
  delete Component.options._Ctor
}
